
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Star } from "lucide-react";
import { Link } from "react-router-dom";
import { useSavedArticles } from "@/hooks/useSavedArticles";
import { Skeleton } from "@/components/ui/skeleton";

export const SavedArticles = () => {
  const { savedArticles, isLoading } = useSavedArticles();

  if (isLoading) {
    return (
      <Card>
        <CardHeader>
          <Skeleton className="h-8 w-48" />
          <Skeleton className="h-4 w-32" />
        </CardHeader>
        <CardContent>
          <div className="space-y-4">
            {[1, 2, 3].map((i) => (
              <div key={i} className="border-b pb-4 last:border-0 last:pb-0">
                <Skeleton className="h-6 w-full mb-2" />
                <Skeleton className="h-4 w-32" />
              </div>
            ))}
          </div>
        </CardContent>
      </Card>
    );
  }

  if (!savedArticles.length) {
    return (
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center">
            <Star className="mr-2 h-5 w-5" />
            Saved Articles
          </CardTitle>
          <CardDescription>No articles saved yet</CardDescription>
        </CardHeader>
        <CardContent>
          <p className="text-sm text-gray-500">
            Articles you save will appear here
          </p>
        </CardContent>
        <CardFooter>
          <Link to="/articles" className="w-full">
            <Button variant="outline" className="w-full">
              Browse Articles
            </Button>
          </Link>
        </CardFooter>
      </Card>
    );
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center">
          <Star className="mr-2 h-5 w-5" />
          Saved Articles
        </CardTitle>
        <CardDescription>Articles you've saved for later</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          {savedArticles.map((article) => (
            <div key={article.id} className="border-b pb-4 last:border-0 last:pb-0">
              <Link to={`/article/${article.id}`}>
                <h3 className="font-medium hover:text-ai-indigo cursor-pointer">
                  {article.title}
                </h3>
              </Link>
              <div className="mt-1 flex items-center justify-between">
                <p className="text-sm text-gray-500">
                  {article.readTime} • {article.date}
                </p>
                <Link to={`/article/${article.id}`}>
                  <Button variant="ghost" size="sm" className="text-gray-500 hover:text-ai-indigo">
                    Read Now
                  </Button>
                </Link>
              </div>
            </div>
          ))}
        </div>
      </CardContent>
      <CardFooter>
        <Link to="/articles" className="w-full">
          <Button variant="outline" className="w-full">
            Browse More Articles
          </Button>
        </Link>
      </CardFooter>
    </Card>
  );
};
